import React, { useState } from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    GridContainer,
    GridItem1,
    GridItem3xs6,
    GridItem4,
    GridItem4xs5,
    GridItem4xs6,
    GridItem5xs10,
    GridItem6,
    GridItem6xs1,
    GridItem6xs11,
    GridItem7,
    GridItem8,
    GridItem8xs10,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDividerElementos,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    TextValidatorNumber,
    TextValidatorNumberRequired,
    TextValidatorValor,
    TextValidatorValorRequired,
    TextValidatorMesAno,
    TextValidatorMesAnoRequired,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldNumberSelectDestaque,
} from '../../../business-components/TextField/TextFieldSelect'

import { 
    CustomizedDialogsMensagem,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    CircularProgressPadrao,
} from '../../../business-components/CircularProgress/CircularProgress'

import {
    UploadFile,
} from '../../../business-components/UploadFile/UploadFile'

import {
    processaUploadAvulso,
} from '../integracaoClienteArquivo-list/IntegracaoClienteArquivoService'

import {
    incluirParcelasImportadas,
} from './DespesasServiceFinanciamento'

import {
    InformacoesOpcionaisNaoAfetamCalculo
} from '../cliente-form/ClienteComp'

import {
    TipoFinanciamento,
    IconButtonClearEntradaDadosFinanciamento,
    TabelaSAC,
    Consorcio,
    ValorParcela,
    QtdeParcelas,
    ValorTotalParcelas,
    ValorSaldoDevedor,
    HelpValorSaldoDevedor,
    TemSeguro,
    HelpTemSeguro,
    PercSeguroCliente,
    PercSeguroConjuge,
    AlterarPercSeguroConjuge,
    PercSeguro,
    FinanciamentoFuturo,
    MesAnoInicial,
    HelpMesAnoInicial,
    FinanciamentoFuturoAindaNaoContratado,
    HelpFinanciamentoFuturoAindaNaoContratado,
    FinanciamentoSeraQuitadoAntesUltimaParcela,
    UltimaParcelaFinanciamento,
    HelpFinanciamentoSeraQuitadoAntesUltimaParcela,
    ConsumirRecursosFinanceirosEmVezDaReceitaMensal,
    HelpConsumirRecursosFinanceirosEmVezDaReceitaMensal,
    GrupoDespesa,
    PossuiParcelasAdicionais,
    Instituicao,
    MesAnoPrimeiroReajuste,
    TaxaAnual,
    TaxaAnualTR,
    HelpTaxaAnualConsorcio,
    DescricaoOutros,
    HelpDescricaoOutros,
    ValorCreditoConsorcio,
    PrazoTotalGrupoConsorcio,
    TaxaAdministracao,
    PercFundoReserva,
    PercRedutorParcela,
    PercSeguroPrestamista,
    ValorCreditoConsorcioContemplacao,
    MesAnoInicialAluguelAposContemplacao,
    PercAluguelMensalAposContemplacao,
    PercReajusteAluguelAnualAposContemplacao,
    ValorAluguelAposContemplacao,
    PercValorizacaoImovelAluguelAposContemplacao,
    MesAnoVendaAposQuitacao,
    Observacao,
} from './DespesasCompFinanciamento'

import DespesasFormFinanciamentoParcelasAdicionais from './DespesasFormFinanciamentoParcelasAdicionais'



const DespesasFormFinanciamentoItem = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, arrayHelpers,
    linhaTipoLicenca, tipoFinanciamentoSelecionado, item, ind, simplificado }) => {

    const [statusUpload, setStatusUpload] = useState(false)

    const [processing, setProcessing] = useState(false)

    const carregarParcelas = async ( e, item, ind ) => {

        setProcessing(true)

        const { erros, listaErros } =
            await processaUploadAvulso(variaveisGlobais, values, item, e.target.files, LABEL.financiamento)

        if (erros > 0) {

            setStatusUpload(
                MESSAGE().statusIntegracaoAvulso
                    .replace("$1$", erros)
                        .replace("$2$", listaErros)
            )

        } else {

            incluirParcelasImportadas(values, item)
        }

        setProcessing(false)
    }



    const isXsDownScreen = IsXsDownScreen()


    
    return (
        <CardGridEntradaDados>
            <CardGridDivHeaderEntradaDados>
                <GridContainer>
                    <GridItem5xs10>
                        <TipoFinanciamento
                            TextFieldNumberSelectTipoFinanciamento={TextFieldNumberSelectDestaque}
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem5xs10>
                    <GridItem6xs1 />
                    <GridItem1>
                        {arrayHelpers && (
                            <IconButtonClearEntradaDadosFinanciamento
                                values={values}
                                setFieldValue={setFieldValue}
                                ind={ind}
                                arrayHelpers={arrayHelpers}
                                simplificado={simplificado}
                            />
                        )}
                    </GridItem1>
                </GridContainer>
            </CardGridDivHeaderEntradaDados>

            <CardGridDivBodyEntradaDados
                style={{
                    display: 
                        item.tipoFinanciamento
                            ? "block"
                            : "none"
                }} 
            >
                {(tipoFinanciamentoSelecionado.informaTabelaSAC === "S" || tipoFinanciamentoSelecionado.informaConsorcio === "S") && (
                    <GridContainer>
                        {tipoFinanciamentoSelecionado.informaTabelaSAC === "S" && !item.consorcio && (
                            <GridItem6>
                                <TabelaSAC
                                    values={values}
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem6>
                        )}

                        {tipoFinanciamentoSelecionado.informaConsorcio === "S" && !item.tabelaSAC && (
                            <GridItem6>
                                <Consorcio
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem6>
                        )}
                    </GridContainer>
                )}
                
                <GridContainer>
                    {!item.tabelaSAC && (
                        <GridItem4xs6>
                            <ValorParcela
                                item={item}
                                ind={ind}
                                label={LABEL.valorParcela}
                                handleChange={handleChange}
                                disabled={false}
                            />
                        </GridItem4xs6>
                    )}
                    {item.tabelaSAC && (
                        <GridItem4xs6>
                            <ValorSaldoDevedor
                                TextValidatorValorValorSaldoDevelor={TextValidatorValorRequired}
                                values={values}
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem4xs6>
                    )}
                    <GridItem4xs5>
                        <QtdeParcelas
                            values={values}
                            item={item}
                            ind={ind}
                            label={LABEL.qtdeParcelasAbreviado}
                            handleChange={handleChange}
                        />
                    </GridItem4xs5>
                    {item.tabelaSAC && (
                        <GridItem4xs6>
                             <TaxaAnual
                                TextValidatorNumberRequiredTaxaAnual={TextValidatorNumberRequired}
                                values={values}
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem4xs6>
                    )}
                </GridContainer>

                {item.valorTotalParcelas !== 0 && (
                    <GridContainer>
                        {item.tabelaSAC && (
                            <GridItem4xs6>
                                <TaxaAnualTR
                                    values={values}
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs6>
                        )}
                        <GridItem4xs6>
                            <ValorTotalParcelas
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem4xs6>
                        {!item.tabelaSAC && (
                            <>
                                <GridItem4xs5>
                                    <ValorSaldoDevedor
                                        TextValidatorValorValorSaldoDevelor={TextValidatorValor}
                                        values={values}
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange}
                                    />
                                </GridItem4xs5>
                                <GridItem1
                                    className={isXsDownScreen ? 'ml--3' : ''}
                                >
                                    <HelpValorSaldoDevedor/>
                                </GridItem1>
                            </>
                        )}
                        {item.tabelaSAC && (
                            <GridItem4xs5>
                                <ValorParcela
                                    item={item}
                                    ind={ind}
                                    label={LABEL.valorParcelaAtual}
                                    handleChange={handleChange}
                                    disabled={true}
                                />
                            </GridItem4xs5>
                        )}
                    </GridContainer>
                )}

                {(item.consorcio || tipoFinanciamentoSelecionado.informaMesAnoPrimeiroReajuste === 'S') && (
                    <GridContainer>
                        <GridItem4xs5>
                            <MesAnoPrimeiroReajuste
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                                TextValidatorMesAnoRequiredPrimeiroReajuste={
                                    tipoFinanciamentoSelecionado.informaMesAnoPrimeiroReajuste === 'S'
                                        ?
                                            TextValidatorMesAno
                                        :
                                            TextValidatorMesAnoRequired
                                }
                            />
                        </GridItem4xs5>
                        <GridItem4xs6>
                             <TaxaAnual
                                TextValidatorNumberRequiredTaxaAnual={
                                    item.consorcio || item.mesAnoPrimeiroReajuste
                                        ? 
                                            TextValidatorNumberRequired
                                        :
                                            TextValidatorNumber
                                }
                                values={values}
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem4xs6>
                        <GridItem1
                            className={isXsDownScreen ? 'ml--3' : ''}
                        >
                            <HelpTaxaAnualConsorcio/>
                        </GridItem1>
                    </GridContainer>
                )}

                <GridContainer>
                    <GridItem11>
                        <DescricaoOutros
                            item={item}
                            ind={ind}
                            handleChange={handleChange} 
                        />
                    </GridItem11>

                    <GridItem1
                        className={isXsDownScreen ? 'ml--3' : ''}
                    >
                        <HelpDescricaoOutros/>
                    </GridItem1>
                </GridContainer>

                <GridContainer>
                    <GridItem6xs11>
                        <GrupoDespesa
                            item={item}
                            ind={ind}
                            handleChange={handleChange} 
                        />
                    </GridItem6xs11>
                </GridContainer>

                {tipoFinanciamentoSelecionado.informaParcelasAdicionais === "S" && (
                    <>
                        <CardGridDividerElementos/>

                        <PossuiParcelasAdicionais
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />

                        {item.possuiParcelasAdicionais && (
                            <>
                                <DespesasFormFinanciamentoParcelasAdicionais
                                    values={values}
                                    handleChange={handleChange}
                                    handleSubmit={handleSubmit}
                                    indFinanciamento={ind}
                                />

                                <GridItem12
                                    className='mb-2'
                                >
                                    <UploadFile
                                        id={"upload-arquivo-PDF" + ind}
                                        label={LABEL.buttonUploadParcelas}
                                        accept=".pdf,.xlsx"
                                        onChange={(e) => {
                                            carregarParcelas(e, item, ind)
                                        }}
                                        multiple={false}
                                        disabled={
                                            processing
                                        }
                                    />
                                </GridItem12>

                                {statusUpload
                                    ?
                                        <CustomizedDialogsMensagem
                                            confirmacaoTitle={LABEL.buttonUploadArquivos}
                                            confirmacaoText={statusUpload}
                                            onClick={() => {
                                                setStatusUpload(false)
                                            }}
                                        />
                                    :
                                        ''
                                }

                                {processing && (
                                    <CircularProgressPadrao />
                                )}
                            </>
                        )}
                    </>
                )}

                {tipoFinanciamentoSelecionado.informaTemSeguro === "S" && (
                    <>
                        <CardGridDividerElementos/>

                        <GridContainer>
                            <GridItem4xs6>
                                <TemSeguro
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs6>
                            {item.temSeguro === "S" &&
                            (
                                item.familiar === HARDCODE.idFamiliarCliente ||
                                item.familiar === HARDCODE.idFamiliarConjuge
                            ) && (
                                <>
                                    <GridItem3xs6>
                                        <PercSeguroCliente
                                            values={values}
                                            item={item}
                                            ind={ind}
                                            handleChange={handleChange}
                                        />
                                    </GridItem3xs6>
                                    <GridItem3xs6>
                                        <PercSeguroConjuge
                                            values={values}
                                            item={item}
                                            ind={ind}
                                            handleChange={handleChange}
                                        />
                                    </GridItem3xs6>
                                </>
                            )}
                            {item.temSeguro === "S" &&
                            item.familiar !== HARDCODE.idFamiliarCliente &&
                            item.familiar !== HARDCODE.idFamiliarConjuge && (
                                <GridItem3xs6>
                                    <PercSeguro
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange}
                                    />
                                </GridItem3xs6>
                            )}
                            <GridItem1>
                                <HelpTemSeguro/>
                            </GridItem1>
                        </GridContainer>
                    </>
                )}

                {item.temSeguro === "S" &&
                (
                    item.familiar === HARDCODE.idFamiliarCliente ||
                    item.familiar === HARDCODE.idFamiliarConjuge
                ) && (
                    <GridContainer>
                        {!isXsDownScreen && (
                            <GridItem7/>
                        )}

                        <GridItem4>
                            <AlterarPercSeguroConjuge
                                values={values}
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem4>
                    </GridContainer>
                )}

                <CardGridDividerElementos/>

                <GridContainer>
                    <GridItem8xs10>
                        <FinanciamentoFuturo
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem8xs10>
                    {item.financiamentoFuturo
                        ?
                            <GridItem4xs6>
                                <MesAnoInicial
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs6>
                        :
                            <GridItem1>
                                <HelpMesAnoInicial/>
                            </GridItem1>
                    }
                </GridContainer>
                
                {item.financiamentoFuturo && (
                    <GridContainer>
                        <GridItem8xs10>
                            <FinanciamentoFuturoAindaNaoContratado
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem8xs10>
                        <GridItem1
                            className='mt--2'
                        >
                            <HelpFinanciamentoFuturoAindaNaoContratado/>
                        </GridItem1>
                    </GridContainer>
                )}

                {item.tabelaSAC && (
                    <GridContainer>
                        <GridItem8xs10>
                            <FinanciamentoSeraQuitadoAntesUltimaParcela
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem8xs10>
                        {item.financiamentoSeraQuitadoAntesUltimaParcela
                            ?
                                <GridItem4xs6>
                                    <UltimaParcelaFinanciamento
                                        values={values}
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange}
                                    />
                                </GridItem4xs6>
                            :
                                <GridItem1
                                    className='mt--2'
                                >
                                    <HelpFinanciamentoSeraQuitadoAntesUltimaParcela/>
                                </GridItem1>
                        }
                    </GridContainer>
                )}

                {(linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S' ||
                linhaTipoLicenca.exibirSomenteConsorcio === 'S') && (
                    <GridContainer>
                        <GridItem8xs10>
                            <ConsumirRecursosFinanceirosEmVezDaReceitaMensal
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem8xs10>
                        <GridItem1
                            className='mt--2'
                        >
                            <HelpConsumirRecursosFinanceirosEmVezDaReceitaMensal/>
                        </GridItem1>
                    </GridContainer>
                )}

                <CardGridDividerElementos/>

                <InformacoesOpcionaisNaoAfetamCalculo />

                <GridContainer>
                    <GridItem8>
                        <Instituicao
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem8>
                    {!item.tabelaSAC && !item.consorcio && tipoFinanciamentoSelecionado.informaMesAnoPrimeiroReajuste === 'N' && (
                        <GridItem4>
                             <TaxaAnual
                                TextValidatorNumberRequiredTaxaAnual={TextValidatorNumber}
                                values={values}
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem4>
                    )}
                </GridContainer>

                {item.consorcio && (
                    <>
                        <GridContainer>
                            <GridItem4xs6>
                                <ValorCreditoConsorcio
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs6>
                            <GridItem4xs6>
                                <PrazoTotalGrupoConsorcio
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs6>
                            <GridItem4xs6>
                                <TaxaAdministracao
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs6>
                        </GridContainer>
                            
                        <GridContainer>
                            <GridItem4xs6>
                                <PercFundoReserva
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs6>
                            <GridItem4xs6>
                                <PercRedutorParcela
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs6>
                            <GridItem4xs6>
                                <PercSeguroPrestamista
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs6>
                        </GridContainer>
                        </>
                )}

                {(item.consorcio || item.tipoFinanciamento === HARDCODE.idTipoFinanciamentoImovel) && (
                    <>
                        <GridContainer>
                            <GridItem4xs6>
                                <ValorCreditoConsorcioContemplacao
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs6>

                            <GridItem4xs6>
                                <MesAnoInicialAluguelAposContemplacao
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs6>

                            <GridItem4xs6>
                                <PercAluguelMensalAposContemplacao
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs6>
                        </GridContainer>

                        <GridContainer>
                            <GridItem4xs6>
                                <ValorAluguelAposContemplacao
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs6>

                             <GridItem4xs6>
                                <PercReajusteAluguelAnualAposContemplacao
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs6>

                            <GridItem4xs6>
                                <PercValorizacaoImovelAluguelAposContemplacao
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs6>
                            
                            <GridItem4xs6>
                                <MesAnoVendaAposQuitacao
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs6>
                        </GridContainer>
                    </>
                )}

                <CardGridDividerElementos/>

                <GridContainer>
                    <GridItem12>
                        <Observacao
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem12>
                </GridContainer>
            </CardGridDivBodyEntradaDados>
        </CardGridEntradaDados>
    )
}

export default DespesasFormFinanciamentoItem